import type { Anime } from "@/types";

export const animes: Anime[] = [
  {
    id: "a01",
    title: "星海旅人",
    titleJa: "星海の旅人",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20key%20visual%20poster%20of%20a%20lone%20young%20space%20traveler%20in%20a%20white%20suit%20floating%20before%20a%20giant%20ringed%20planet%2C%20deep%20indigo%20starry%20night%20sky%2C%20glowing%20constellations%2C%20cinematic%20lighting%2C%20clean%20minimal%20background%2C%20high%20detail%20anime%20illustration&width=600&height=800&seq=anime-cover-01&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20anime%20scene%20of%20a%20spaceship%20drifting%20through%20a%20purple%20and%20pink%20nebula%2C%20distant%20ringed%20planet%2C%20luminous%20stardust%2C%20deep%20blue%20space%2C%20dramatic%20lighting%2C%20detailed%20anime%20background%20art&width=1600&height=900&seq=anime-banner-01&orientation=landscape",
    year: 2024,
    episodes: 24,
    status: "连载中",
    rating: 9.1,
    categories: ["科幻", "冒险"],
    director: "白石遥",
    studio: "STARLIGHT 动画工作室",
    tags: ["宇宙", "成长", "羁绊", "星际旅行"],
    synopsis:
      "少年阿星偶然获得一枚会发光的神秘罗盘，从此踏上寻找失落故乡的星际旅程。旅途中他遇见各怀心事的伙伴，也逐渐揭开宇宙「静默区」背后的秘密。",
    story:
      "在人类已能自由穿梭星海的年代，少年阿星却出生在被称为「静默区」的边缘地带——这里没有航线，也没有归属。一枚会随心跳亮起的罗盘让他意识到，自己的身世或许与传说中消失的母星有关。为了寻找答案，他与冷漠的导航员、话痨的机械师和沉默的护卫一同出发，在无数星球间辗转。每一次靠岸都是新的抉择，每一段相遇都推动着他们向真相靠近。",
    characterIds: ["c01", "c02", "c03"],
  },
  {
    id: "a02",
    title: "樱花之约",
    titleJa: "桜の約束",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20poster%20of%20a%20high%20school%20girl%20and%20boy%20standing%20under%20blooming%20cherry%20blossom%20trees%2C%20soft%20pink%20petals%20falling%2C%20warm%20spring%20afternoon%20light%2C%20gentle%20romantic%20mood%2C%20clean%20background%2C%20detailed%20anime%20illustration&width=600&height=800&seq=anime-cover-02&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Wide%20anime%20scene%20of%20a%20school%20path%20lined%20with%20full%20bloom%20cherry%20trees%20in%20soft%20pink%2C%20petals%20swirling%20in%20sunlight%2C%20distant%20students%20in%20uniforms%2C%20warm%20spring%20atmosphere%2C%20anime%20background%20art&width=1600&height=900&seq=anime-banner-02&orientation=landscape",
    year: 2023,
    episodes: 13,
    status: "已完结",
    rating: 8.7,
    categories: ["恋爱", "校园"],
    director: "望月结衣",
    studio: "春日野制作",
    tags: ["青春", "初恋", "樱花", "校园"],
    synopsis:
      "转学生小凛与儿时玩伴在樱花树下重逢，一句被风吹散的约定，成了两人重新认识彼此的契机。",
    story:
      "小凛转学回到阔别七年的小镇，第一眼看到的就是校门口那棵巨大的樱花树。树下，她遇见了那个总爱逞强的少年——小时候一起埋下时间胶囊的伙伴。两人小心翼翼地绕开过去，却在一次次放学后的同行、社团的意外合作中慢慢靠近。樱花只开一周，但有些约定值得等上一整年。",
    characterIds: ["c04", "c05", "c06"],
  },
  {
    id: "a03",
    title: "剑与晨曦",
    titleJa: "剣と暁",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20poster%20of%20a%20young%20swordsman%20holding%20a%20glowing%20katana%20at%20dawn%2C%20dramatic%20orange%20sunrise%20sky%2C%20flowing%20cloak%2C%20epic%20fantasy%20battle%20mood%2C%20clean%20minimal%20background%2C%20detailed%20anime%20illustration&width=600&height=800&seq=anime-cover-03&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Wide%20epic%20anime%20battlefield%20scene%20at%20sunrise%2C%20golden%20light%20spilling%20over%20misty%20mountains%2C%20a%20lone%20warrior%20silhouette%20with%20sword%2C%20warm%20orange%20and%20amber%20tones%2C%20anime%20background%20art&width=1600&height=900&seq=anime-banner-03&orientation=landscape",
    year: 2025,
    episodes: 26,
    status: "连载中",
    rating: 8.9,
    categories: ["热血", "奇幻"],
    director: "黑川武藏",
    studio: "晓之刃动画",
    tags: ["剑术", "成长", "师徒", "光明与黑暗"],
    synopsis:
      "失去记忆的少年剑士被老铁匠收留，为了弄清手中黑刀的秘密，他踏上寻找「晨曦之刃」的修行之旅。",
    story:
      "少年在雾之国醒来时，只记得一个「斩」字。老铁匠告诉他，那把黑刀来自百年前被封印的灾厄。为了不被黑刀吞噬，他必须在月圆之前找到传说中能净化刀魂的「晨曦之刃」。一路上，他挑战各派剑客，也直面自己内心的阴影，在每一次挥刀中重新定义什么叫强大。",
    characterIds: ["c07", "c08", "c09"],
  },
  {
    id: "a04",
    title: "料理少女小町",
    titleJa: "お料理少女こまち",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20poster%20of%20a%20cheerful%20high%20school%20girl%20chef%20holding%20a%20wooden%20spoon%2C%20warm%20cozy%20kitchen%20with%20steaming%20dishes%2C%20soft%20cream%20and%20peach%20tones%2C%20healing%20slice%20of%20life%20mood%2C%20clean%20background%2C%20detailed%20anime%20illustration&width=600&height=800&seq=anime-cover-04&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Wide%20cozy%20anime%20kitchen%20scene%20with%20wooden%20counters%2C%20fresh%20ingredients%2C%20warm%20golden%20afternoon%20light%20through%20window%2C%20steam%20rising%20from%20pots%2C%20soft%20warm%20tones%2C%20anime%20background%20art&width=1600&height=900&seq=anime-banner-04&orientation=landscape",
    year: 2022,
    episodes: 12,
    status: "已完结",
    rating: 8.4,
    categories: ["治愈", "校园"],
    director: "小豆泽千夏",
    studio: "暖炉工房",
    tags: ["美食", "日常", "治愈", "社团"],
    synopsis:
      "料理社新成员小町用一道道温暖的家常菜，化解同学们的烦恼，也慢慢找到了自己的味道。",
    story:
      "小町加入料理社的原因很简单——她只是想做出能把人留住的饭菜。从第一份失败的亲子丼开始，她用最朴素的食材去回应每一份心事：为考前焦虑的学姐做暖胃的粥，为闹别扭的双胞胎做一分为二的甜点。食物不解决所有问题，但总能在最需要的时候，让人觉得「明天也可以再试一次」。",
    characterIds: ["c10", "c11", "c12"],
  },
  {
    id: "a05",
    title: "机械都市诺瓦",
    titleJa: "機械都市ノヴァ",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20poster%20of%20a%20futuristic%20neon%20city%20with%20towering%20machines%2C%20a%20female%20engineer%20in%20a%20sleek%20jacket%20looking%20up%2C%20cool%20teal%20and%20magenta%20lights%2C%20cyberpunk%20mood%2C%20clean%20background%2C%20detailed%20anime%20illustration&width=600&height=800&seq=anime-cover-05&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Wide%20anime%20scene%20of%20a%20sprawling%20cyberpunk%20cityscape%20at%20night%2C%20teal%20and%20magenta%20neon%20reflections%20on%20wet%20streets%2C%20flying%20vehicles%2C%20towering%20skyscrapers%2C%20anime%20background%20art&width=1600&height=900&seq=anime-banner-05&orientation=landscape",
    year: 2024,
    episodes: 22,
    status: "连载中",
    rating: 8.8,
    categories: ["科幻", "悬疑"],
    director: "结城零",
    studio: "NOX 动画",
    tags: ["赛博朋克", "推理", "人工智能", "反乌托邦"],
    synopsis:
      "在由中央 AI「诺瓦」管理的巨型都市里，一名机械维修师发现全城记忆正在被悄悄改写。",
    story:
      "诺瓦市的一切都由中央 AI 调度：交通、能源，甚至市民的记忆。维修师凛过着按部就班的日子，直到她在修理一台旧机械时，读到了一段「不存在」的记忆。顺着这条线索，她闯入了城市最底层的数据迷宫，发现所谓的完美秩序背后，藏着一个关于自由意志的惊人真相。",
    characterIds: ["c13", "c14", "c15"],
  },
  {
    id: "a06",
    title: "妖怪食堂",
    titleJa: "妖怪食堂",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20poster%20of%20a%20tiny%20warm%20night%20eatery%20with%20friendly%20Japanese%20yokai%20spirits%20gathering%2C%20paper%20lanterns%20glowing%20warm%20amber%2C%20cozy%20mystical%20atmosphere%2C%20clean%20background%2C%20detailed%20anime%20illustration&width=600&height=800&seq=anime-cover-06&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Wide%20anime%20scene%20of%20a%20small%20wooden%20food%20stall%20in%20a%20misty%20forest%20at%20night%2C%20warm%20lantern%20light%2C%20faint%20yokai%20silhouettes%2C%20mystical%20cozy%20mood%2C%20anime%20background%20art&width=1600&height=900&seq=anime-banner-06&orientation=landscape",
    year: 2021,
    episodes: 12,
    status: "已完结",
    rating: 8.6,
    categories: ["奇幻", "治愈"],
    director: "森野旅人",
    studio: "鬼灯社",
    tags: ["妖怪", "美食", "温情", "怪谈"],
    synopsis:
      "只在深夜营业的食堂，招待的客人一半是人，一半是妖怪，而每道菜都藏着一段未了的心愿。",
    story:
      "城市边缘的巷子里，有一家只在午夜亮灯的小食堂。老板沉默寡言，却能端出每位客人「最想吃的那一道」。雪女想要一碗不会化的冰，河童惦记着故乡的黄瓜，而误入的人类客人，则在这里重新想起被遗忘的承诺。妖怪与人的界限，在一碗热汤前变得模糊。",
    characterIds: ["c16", "c17", "c18"],
  },
  {
    id: "a07",
    title: "篮球少年燃",
    titleJa: "バスケ少年エン",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20poster%20of%20a%20determined%20teenage%20basketball%20player%20mid%20jump%20shot%2C%20high%20school%20gym%20background%2C%20warm%20orange%20and%20cream%20tones%2C%20dynamic%20sports%20energy%2C%20clean%20background%2C%20detailed%20anime%20illustration&width=600&height=800&seq=anime-cover-07&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Wide%20anime%20scene%20of%20an%20intense%20high%20school%20basketball%20game%20in%20a%20packed%20gym%2C%20motion%20blur%2C%20warm%20spotlights%2C%20crowd%20cheering%2C%20energetic%20sports%20atmosphere%2C%20anime%20background%20art&width=1600&height=900&seq=anime-banner-07&orientation=landscape",
    year: 2023,
    episodes: 25,
    status: "已完结",
    rating: 8.5,
    categories: ["热血", "校园"],
    director: "山吹大辅",
    studio: "扣篮动画",
    tags: ["篮球", "团队", "青春", "竞技"],
    synopsis:
      "身高不足却弹跳惊人的少年阿燃，为了守住即将解散的篮球社，带领一群「问题社员」冲击全国大赛。",
    story:
      "篮球社只剩下五个人，还差一人就要被取消。转学生阿燃带着一身野球场的坏习惯加入，却用一次次不讲道理的暴扣点燃了整个队伍。他们吵架、失误、互相不服气，却在每一场硬仗里学会把后背交给队友。所谓燃，不是天赋，而是明知会输也要打完最后一秒。",
    characterIds: ["c19", "c20", "c21"],
  },
  {
    id: "a08",
    title: "天空之城的信",
    titleJa: "空の城の手紙",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20poster%20of%20a%20young%20postman%20on%20a%20flying%20bicycle%20above%20floating%20islands%20and%20clouds%2C%20blue%20sky%20with%20soft%20cream%20clouds%2C%20adventurous%20whimsical%20mood%2C%20clean%20background%2C%20detailed%20anime%20illustration&width=600&height=800&seq=anime-cover-08&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Wide%20anime%20scene%20of%20floating%20islands%20among%20sunlit%20clouds%2C%20a%20small%20airship%20sailing%20between%20them%2C%20soft%20blue%20and%20cream%20sky%2C%20serene%20fantasy%20adventure%20mood%2C%20anime%20background%20art&width=1600&height=900&seq=anime-banner-08&orientation=landscape",
    year: 2022,
    episodes: 24,
    status: "已完结",
    rating: 8.7,
    categories: ["冒险", "奇幻"],
    director: "云居遥",
    studio: "浮空社",
    tags: ["飞行", "冒险", "信使", "奇幻世界"],
    synopsis:
      "在这个世界，信要送到天上。少年邮差骑着飞行单车穿越云海，只为把一封迟到十年的信送达。",
    story:
      "当大地被云海淹没，人类栖居在漂浮的岛屿上，信件成了连接孤岛的唯一纽带。少年邮差云生接管了祖父留下的航线，第一单就指向传说中已经消失的「天空之城」。他带着一封泛黄的信穿过风暴与浮空兽群，逐渐明白：有些信不只为送达，更为让等待的人知道，自己被记得。",
    characterIds: ["c22", "c23", "c24"],
  },
  {
    id: "a09",
    title: "深夜咖啡馆",
    titleJa: "深夜カフェ",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20poster%20of%20a%20cozy%20late%20night%20cafe%20with%20warm%20amber%20lighting%2C%20a%20barista%20and%20a%20guest%20talking%20quietly%2C%20rain%20on%20window%2C%20intimate%20healing%20mood%2C%20clean%20background%2C%20detailed%20anime%20illustration&width=600&height=800&seq=anime-cover-09&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Wide%20anime%20scene%20of%20a%20small%20cafe%20interior%20at%20night%2C%20warm%20hanging%20lamps%2C%20rainy%20street%20visible%20through%20the%20glass%2C%20cozy%20intimate%20atmosphere%2C%20warm%20amber%20tones%2C%20anime%20background%20art&width=1600&height=900&seq=anime-banner-09&orientation=landscape",
    year: 2025,
    episodes: 13,
    status: "连载中",
    rating: 8.6,
    categories: ["治愈", "恋爱"],
    director: "雨宫樟",
    studio: "月光工房",
    tags: ["咖啡", "都市", "慢节奏", "相遇"],
    synopsis:
      "只在雨天营业的咖啡馆，老板会根据客人的心情调一杯特调，而每一杯咖啡背后都有一段未说完的话。",
    story:
      "这家咖啡馆没有招牌，只在雨天开门。老板习惯用一杯咖啡换一个故事：加班到深夜的上班族、刚结束一段关系的人、总在同一位置等人的常客。在这里，陌生人短暂地交出各自的心事，然后带着一点暖意重新走进雨里。而老板自己那杯始终没喝完的咖啡，也在等待一个人。",
    characterIds: ["c25", "c26", "c27"],
  },
  {
    id: "a10",
    title: "咒术回响",
    titleJa: "呪術のこだま",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20poster%20of%20a%20young%20exorcist%20with%20glowing%20crimson%20runes%20floating%20around%20his%20hand%2C%20dark%20mystical%20atmosphere%2C%20dramatic%20red%20and%20black%20tones%2C%20clean%20background%2C%20detailed%20anime%20illustration&width=600&height=800&seq=anime-cover-10&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Wide%20anime%20scene%20of%20an%20ancient%20shrine%20at%20dusk%20with%20floating%20glowing%20runes%2C%20dark%20crimson%20and%20charcoal%20tones%2C%20ominous%20supernatural%20mood%2C%20anime%20background%20art&width=1600&height=900&seq=anime-banner-10&orientation=landscape",
    year: 2024,
    episodes: 24,
    status: "连载中",
    rating: 9.0,
    categories: ["奇幻", "热血"],
    director: "影山柊",
    studio: "回响动画",
    tags: ["咒术", "战斗", "宿命", "超自然"],
    synopsis:
      "能听见「咒」之声的少年，被迫卷入驱邪师与诅咒之物的百年战争，而他自己的身体，正是最大的诅咒。",
    story:
      "少年柊从小就能听见别人听不到的低语——那是被封印的「咒」。一次意外让他体内的咒印苏醒，也把他推入了驱邪师的世界。为了不被咒吞噬，他必须在一次次生死战斗中学会与体内的声音共存。而随着真相浮现，他发现所谓驱邪师与诅咒，或许本就是同一枚硬币的两面。",
    characterIds: ["c28", "c29", "c30"],
  },
  {
    id: "a11",
    title: "时间侦探事务所",
    titleJa: "時間探偵事務所",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20poster%20of%20a%20sharp%20young%20detective%20holding%20a%20glowing%20pocket%20watch%2C%20surrounded%20by%20floating%20clock%20faces%2C%20moody%20teal%20and%20cream%20tones%2C%20mystery%20mood%2C%20clean%20background%2C%20detailed%20anime%20illustration&width=600&height=800&seq=anime-cover-11&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Wide%20anime%20scene%20of%20a%20dim%20detective%20office%20with%20hundreds%20of%20clocks%20on%20the%20wall%2C%20moonlight%20through%20venetian%20blinds%2C%20teal%20and%20cream%20tones%2C%20mysterious%20mood%2C%20anime%20background%20art&width=1600&height=900&seq=anime-banner-11&orientation=landscape",
    year: 2023,
    episodes: 20,
    status: "已完结",
    rating: 8.9,
    categories: ["悬疑", "科幻"],
    director: "十时零",
    studio: "时钟座",
    tags: ["推理", "时间", "单元剧", "反转"],
    synopsis:
      "只接手「时间相关」案件的事务所，侦探每次只能回到案发前 24 小时，而改变过去必须付出代价。",
    story:
      "时间侦探事务所的门牌下写着一行小字：「本店不接普通案件。」侦探时雨拥有一块能让她回到二十四小时前的老怀表，每次回溯都会让她失去一段记忆。她与助手接手一桩桩看似寻常却暗藏悖论的委托——消失的乘客、重复的一日、预知死亡的信。真相能被改写，但代价必须有人承担。",
    characterIds: ["c31", "c32", "c33"],
  },
  {
    id: "a12",
    title: "夏日烟花",
    titleJa: "夏の花火",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20poster%20of%20two%20teenagers%20in%20yukata%20watching%20fireworks%20over%20a%20riverside%2C%20warm%20summer%20night%2C%20golden%20and%20pink%20fireworks%20in%20dark%20sky%2C%20nostalgic%20romantic%20mood%2C%20clean%20background%2C%20detailed%20anime%20illustration&width=600&height=800&seq=anime-cover-12&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Wide%20anime%20scene%20of%20a%20summer%20festival%20by%20the%20river%2C%20glowing%20lanterns%2C%20fireworks%20blooming%20over%20the%20dark%20sky%2C%20warm%20festive%20nostalgic%20mood%2C%20anime%20background%20art&width=1600&height=900&seq=anime-banner-12&orientation=landscape",
    year: 2021,
    episodes: 12,
    status: "已完结",
    rating: 8.3,
    categories: ["恋爱", "治愈"],
    director: "河合夏帆",
    studio: "花火社",
    tags: ["夏日", "青春", "回忆", "祭典"],
    synopsis:
      "在最后一个可以一起看烟花的夏天，两个即将各奔东西的少年少女，决定把没说出口的话写进夜空。",
    story:
      "小镇的夏日祭每年只放一次烟花，而今年，是他们在同一座小镇的最后一次。少女早已决定去远方的城市，少年却始终没能说出挽留。祭典的夜晚，他们沿着河堤慢慢走，看烟花一朵朵升起又熄灭。有些心意像烟花，短暂却足够照亮整个夏天——哪怕只被一个人看见。",
    characterIds: ["c34", "c35", "c36"],
  },
];